(function() {
    'use strict';

    angular
        .module('getwellApp')
        .constant('paginationConstants', {
            'itemsPerPage': 100
        });
})();
